import { styled, alpha } from '@mui/material/styles';
import { Box, Button, Popper } from '@mui/material';

const primaryDark = '#003e47';
const primaryNeutralsDark10 = '#003e471a';
const primaryNeutralsDark5 = 'rgba(0, 62, 71, 0.05)';
const primaryDisable = 'rgba(0, 62, 71, 0.4)';

export const Container = styled(Box)(() => ({
  position: 'relative',
}));

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'active' && prop !== 'highlighted',
})<{ active?: boolean; highlighted?: boolean }>(({ active, highlighted }) => ({
  justifyContent: 'space-between',
  color: primaryDark,
  textTransform: 'none',
  fontSize: '0.875rem',
  lineHeight: 'inherit',
  padding: '0.6875rem 0.75rem 0.6875rem 0.9375rem',
  fontWeight: 500,
  borderColor: primaryNeutralsDark10,

  '&:hover': {
    background: 'rgba(0, 62, 71, 0.02)',
    borderColor: primaryNeutralsDark10,
    color: '#003e47',
  },

  '& .MuiButton-endIcon': {
    transition: 'transform 200ms',
    ...(active && {
      transform: 'rotate(180deg)',
    }),
  },

  ...(active && {
    background: 'rgba(0, 62, 71, 0.02)',
    borderColor: primaryNeutralsDark10,
    color: primaryDisable,
  }),

  ...(highlighted && {
    backgroundColor: '#fffce4',
  }),
}));

export const CountryLabelWrapper = styled('span')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
}));

export const StyledPopper = styled(Popper)(() => ({
  width: '100%',
  marginTop: '0.5rem !important',
  backgroundColor: '#ffffff',
  zIndex: 2000,
  boxShadow: '0 7px 25px 0 rgba(0, 0, 0, 0.25)',

  '& .MuiAutocomplete-root': {
    border: '2px solid transparent',
    '&.Mui-focused': {
      border: '2px solid rgba(73, 186, 202, 1)',
      borderRadius: '8px',
      '& .MuiInputBase-root': {
        borderBottomColor: 'transparent',
      },
    },
  },

  '& .MuiInputBase-root': {
    padding: '0.125rem 0.75rem',
    borderBottom: '1px solid rgba(235, 240, 240, 1)',
    borderRadius: 0,
    '& fieldset': {
      border: 0,
    },
  },

  '& .MuiAutocomplete-paper': {
    boxShadow: 'none',
  },

  '& .MuiAutocomplete-option': {
    gridGap: '0.875rem',
    fontWeight: 500,
    paddingTop: '0.75rem',
    paddingBottom: '0.75rem',
    borderRadius: '4px',
    '&.Mui-focused': {
      backgroundColor: primaryNeutralsDark5,
    },
  },

  '& .MuiAutocomplete-popper': {
    position: 'static !important',
    transform: 'none !important',
  },
}));

export const ItemLabel = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexGrow: 1,
  gridGap: '1rem',
  color: primaryDark,
}));
